import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getIndexNameDiscovery, algoliaSearchClients } from '../util/algolia.js';

var QUERY_SUGGESTIONS_INDEX_SUFFIX = 'query_suggestions';
var defaultQuerySuggestionSearchParameters = {
  clickAnalytics: true,
  attributesToRetrieve: ['objectID', 'query', 'popularity'],
  attributesToHighlight: ['query'],
  ruleContexts: [],
  getRankingInfo: true
};
var getSuggestedQueries = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
    var query, tenant, environment, locale, querySuggestionSearchParameters, indexName, client, searchParameters, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          query = request.query, tenant = request.tenant, environment = request.environment, locale = request.locale, querySuggestionSearchParameters = request.querySuggestionSearchParameters;
          indexName = "".concat(getIndexNameDiscovery(tenant, environment, locale), "_").concat(QUERY_SUGGESTIONS_INDEX_SUFFIX);
          client = algoliaSearchClients[environment];
          searchParameters = querySuggestionSearchParameters !== null && querySuggestionSearchParameters !== void 0 ? querySuggestionSearchParameters : defaultQuerySuggestionSearchParameters;
          _context.next = 6;
          return client.search({
            requests: [_objectSpread2({
              indexName: indexName,
              query: query
            }, searchParameters)]
          });
        case 6:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSuggestedQueries(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { getSuggestedQueries };
//# sourceMappingURL=algoliaClient.js.map
